import React from 'react';
import { NavLink } from 'react-router-dom';
import { IconHome, IconHistory, IconStore, IconUser } from './icons';

const items = [
  { path:'/wallet',  icon:<IconHome size={20}/>,    label:'الرئيسية' },
  { path:'/history', icon:<IconHistory size={20}/>, label:'العمليات' },
  { icon:<IconStore size={20}/>, label:'المتجر', disabled:true },
  { path:'/account', icon:<IconUser size={20}/>,    label:'حسابي' },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav" style={{
      position:'fixed', bottom:0, left:0, right:0, height:58,
      display:'none', /* يُفعَّل عبر media query أدناه على الشاشات الصغيرة */
      background:'linear-gradient(160deg,#1B1547 0%,#2B2467 60%,#4A3F9E 100%)',
      borderTop:'1px solid rgba(255,255,255,0.08)',
      boxShadow:'0 -2px 14px rgba(0,0,0,0.25)',
      zIndex:98, direction:'rtl', paddingBottom:'env(safe-area-inset-bottom, 0)'
    }}>
      {items.map((item, i) => {
        const content = (
          <div style={{
            display:'flex', flexDirection:'column', alignItems:'center', gap:3,
            padding:'9px 4px', opacity: item.disabled ? 0.4 : 1
          }}>
            <span style={{ display:'flex' }}>{item.icon}</span>
            <span style={{ fontSize:10.5, fontWeight:600 }}>{item.label}</span>
          </div>
        );

        if (item.disabled) {
          return (
            <div key={i} style={{ flex:1, cursor:'not-allowed', color:'rgba(255,255,255,0.4)' }} title="قريباً">
              {content}
            </div>
          );
        }

        return (
          <NavLink key={i} to={item.path} style={({ isActive }) => ({
            flex:1, textDecoration:'none',
            color: isActive ? '#C9974B' : 'rgba(255,255,255,0.55)'
          })}>
            {content}
          </NavLink>
        );
      })}

      <style>{`
        @media (max-width: 768px) {
          .bottom-nav { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
